module.exports = "<!-- Main view/routes wrapper-->\n<!--<p>{{ message | async | json }}</p>-->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main